import { REQUEST } from '../../../utils/actionGenerator';
import { fork, take } from 'redux-saga/effects';
import * as api from '../../../utils/api';
import { fetchEntity } from '../../../store/saga';
import * as actions from './actions';

export function* postPTLBulkMIS(payload) {
  const request = api.createPTLBulkMISRequest.bind(null, payload);
  yield fetchEntity(request, actions.postPTLBulkMIS);
}

export function* getPTLBulkMISTransporters() {
  const request = api.createFetchPTLBulkMISTransportersRequest.bind(null);
  yield fetchEntity(request, actions.getPTLBulkMISTransporters);
}

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/


export function* watchPTLBulkMISSaga() {
  while (true) {
    const { payload, tpt } = yield take(actions.PTL_BULK_MIS[REQUEST]);
    yield fork(postPTLBulkMIS, { payload, tpt });
  }
}

export function* watchPTLBulkMISTransportersSaga() {
  while (true) {
    const { payload, tpt } = yield take(actions.PTL_BULK_MIS_GET_TRANSPORTERS[REQUEST]);
    yield fork(getPTLBulkMISTransporters, { payload, tpt });
  }
}
